import {Component, input} from '@angular/core';

@Component({
  selector: 'app-icon-logout',
  imports: [],
  templateUrl: './icon-logout.component.html'
})
export class IconLogoutComponent {
  color = input('#4f4f4f');
}
